import type { BalanceBillType } from "@/types";

type FileEntry = {
  fileName: string;
};

export const ACCEPTED_BALANCE_BILL_FILE_TYPES = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "application/pdf",
  // "image/heic",
];

export function getExtensionsFromMimeTypes(mimeTypes: string[]): string[] {
  return mimeTypes.map((type) => {
    const parts = type.split("/"); // ["image", "jpeg"]
    return parts[1].toUpperCase(); // "JPEG"
  });
}

export function transformFileList(
  fileList: FileEntry[],
  memberId: string,
): BalanceBillType[] {
  const pad = (num: number, size = 2) => num.toString().padStart(size, "0");

  const formatTimestamp = (timestamp: number): string => {
    const date = new Date(timestamp);
    return (
      `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
      `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.0`
    );
  };

  return fileList.map(({ fileName }) => {
    const prefix = `${memberId}_`;
    const remainder = fileName.slice(prefix.length);
    const timestampStr = remainder.split("_")[0];
    const timestamp = Number(timestampStr);
    const uploadedDate = !isNaN(timestamp)
      ? formatTimestamp(timestamp)
      : "Invalid Timestamp";

    const fileType = fileName.split(".").pop() || "unknown";

    return {
      fileName,
      uploadedDate,
      fileType,
      memberId,
    };
  });
}
